import { FC, useState } from "react";

import { PriceLevelItemDisplay } from "./price-level-item.display";
import { PriceLevelItemEdit } from "./price-level-item.edit";
import { IPriceLevelItemItemForm } from "./price-level.models";

export const PriceLevelItem: FC<IPriceLevelItemItemForm> = ({
  fieldName,
  index,
  pricingType,
  fromValues,
  value,
  setValueOuter,
  removeHandler,
  disabledEdit,
  disabledRemove,
}) => {
  const [inEdit, setInEdit] = useState(false);
  return (
    <>
      {!inEdit && (
        <PriceLevelItemDisplay
          fieldName={fieldName}
          index={index}
          pricingType={pricingType}
          fromValues={fromValues}
          value={value}
          removeHandler={removeHandler}
          onEdit={() => {
            setInEdit(true);
          }}
          disabledEdit={disabledEdit}
          disabledRemove={disabledRemove}
        />
      )}

      {inEdit && (
        <PriceLevelItemEdit
          fieldName={fieldName}
          setValueOuter={setValueOuter}
          index={index}
          pricingType={pricingType}
          fromValues={fromValues}
          value={value}
          onCancelOuter={() => {
            setInEdit(false);
          }}
        />
      )}
    </>
  );
};
